export default () => ({
  newMediaRequestsCount: 0,
});
